import { Box, Typography } from "@mui/material";
import { formatNumber } from "helpers/index";
import { palette } from "theme";
import { getCounterFormulaLabel } from "../utils";
import SectionLabel from "./SectionLabel";

interface TotalQuestionsCardProps {
  totalQuestionsCount: number;
  areasCount: number;
  selectedTypesCount: number;
  amount: string;
}

const TotalQuestionsCard = ({
  totalQuestionsCount,
  areasCount,
  selectedTypesCount,
  amount,
}: TotalQuestionsCardProps) => {
  return (
    <Box sx={{ minWidth: 240 }}>
      <SectionLabel>Итого вопросов</SectionLabel>
      <Box
        sx={{
          position: "relative",
          overflow: "hidden",
          py: 1.5,
          px: 2,
          borderRadius: 1.5,
          color: "common.white",
          background: "linear-gradient(145deg, #2952E3 0%, #4F6EF7 100%)",
          "&::before, &::after": {
            content: '""',
            position: "absolute",
            borderRadius: "50%",
          },
          "&::before": {
            top: -38,
            right: -30,
            width: 130,
            height: 130,
            background: "rgba(255,255,255,.12)",
          },
          "&::after": {
            left: 20,
            bottom: -42,
            width: 92,
            height: 92,
            background: "rgba(255,255,255,.08)",
          },
          "& > *": {
            position: "relative",
            zIndex: 1,
          },
        }}>
        <Typography sx={{ fontSize: 52, fontWeight: 900, color: palette.white, lineHeight: 1 }}>
          {totalQuestionsCount}
        </Typography>
        <Typography sx={{ fontSize: 13, color: "rgba(255,255,255,.72)" }}>
          {formatNumber(["вопрос", "вопроса", "вопросов"], totalQuestionsCount, true)}
        </Typography>
        <Box>
          <Typography sx={{ fontSize: 13, fontWeight: 700, color: palette.white }}>
            {getCounterFormulaLabel({
              areasCount,
              selectedTypesCount,
              amount,
            })}
          </Typography>
          <Typography sx={{ fontSize: 14, color: "rgba(255,255,255,.72)" }}>области × типы × кол-во</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default TotalQuestionsCard;
